



























































import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { resHandle, axiosM } from "@/plugins/axios.ts";
import { validatePhone } from "@/plugins/elValidateRules.ts";
@Component({})
export default class RegisterView extends Vue {
  private register: any = {
    手机号: "",
    验证码: "",
    密码: "",
    姓名: "",
    医院名称: ""
  };
  private rules: any = {
    手机号: [{ required: true, message: "手机号必须填写", trigger: "blur" }],
    验证码: [{ required: true, message: "验证码必须填写", trigger: "blur" }],
    密码: [{ required: true, message: "密码必须填写", trigger: "blur" }],
    姓名: [{ required: true, message: "请输入姓名", trigger: "blur" }]
  };
  private codeState: "able" | "disabled" = "able";
  private codeCountdownTime: number = 60;
  private ifAllow: boolean = false;
  /**
   * @description 倒计时
   */
  private countdownCodeWaitTime() {
    const interval = setInterval(() => {
      this.codeCountdownTime--;
      localStorage.setItem("loginCountDown", String(this.codeCountdownTime));
      if (this.codeCountdownTime === 0) {
        clearInterval(interval);
        this.codeCountdownTime = 60;
        localStorage.setItem("loginCountDown", "60");
        this.codeState = "able";
      }
    }, 1000);
  }
  /**
   * @description 获取验证码
   */
  private getPhoneCode() {
    (this.$refs.registerForm as elForm).validateField("手机号", (msg: any) => {
      if (!msg) {
        const params: any = {
          手机号: this.register["手机号"]
        };
        axios.post("api/user/phonecode", params).then(({ data }) => {
          resHandle(this, data).then(() => {
            this.codeState = "disabled";
            this.countdownCodeWaitTime();
          });
        });
      }
    });
  }
  /**
   * @description 注册
   */
  private registerThis() {
    (this.$refs.registerForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = this.register;
        axios.post("api/user/register", params).then(({ data }) => {
          resHandle(this, data).then(() => {
            this.$message.success("注册成功");
            this.$router.push("/access/login");
          });
        });
      }
    });
  }
  /**
   * @description 前往登录
   */
  private goToLogin() {
    this.$router.push("/access/login");
  }
  /**
   * @description 打开用户协议手册
   */
  private openAgreement() {
    window.open("/#/access/agreement");
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    const n = localStorage.getItem("loginCountDown") || "60";
    this.codeCountdownTime = Number(n);
    if (this.codeCountdownTime !== 60) {
      this.codeState = "disabled";
      this.countdownCodeWaitTime();
    }
  }
}
